import { Card, CardContent } from '@material-ui/core';
import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { IInventoryItem } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { OrientationChipOrNa } from '../inventory-items.components';

interface IProps {
	item: IInventoryItem;
	style?: React.CSSProperties;
	className?: string;
}

export const OrientationCard = ({ item, style, className }: IProps) => {
	const strings = useLocalization();

	return (
		<Card
			style={style}
			className={`df-col ${className}`}>
			<CardContent className='gap-6 df-col'>
				<CardTitleTypography title={strings.orientation} />
				<OrientationChipOrNa orientation={item.latestOrientation} />
			</CardContent>
		</Card>
	);
};
